import { PracticeAdditionalParameter } from '../../../common/_models';

export type SelectedPractice = {
  id: string;
  additionalParameters?: PracticeAdditionalParameter[];
};

// The entity which the path is applied to
export class PlotSelected {
  fieldId: number; // Always valorized
  parcelId: number; // Present if the entity is the Parcel; Null if the entity is the Field

  constructor() {
    this.fieldId = null;
    this.parcelId = null;
  }
}

export class RegenerativePathCreate {
  name: string;
  baseYear: number;
  protocolId: string;
  practicesSelected: SelectedPractice[];
  sections: PlotSelected[]; // the object for the entities which the path is applied to
  companyId: number; // The company creating the path - we take the child'one when logged in as head of Supply Chain using multifarm feature

  constructor() {
    this.name = null;
    this.baseYear = null;
    this.protocolId = null;
    this.practicesSelected = [];
    this.sections = [];
    this.companyId = null;
  }
}
